import { CHARGER_TYPE } from "../enums/chargerType";

const createChargerTypeList = () => {
  const chargerTypeList = Object.values(CHARGER_TYPE);
  return chargerTypeList;
};

export default createChargerTypeList;
